// Copyright (c) 2016 Deere & Company

import * as busyCounter from '../../../shared/action-creators/busy-counter';
import {
    getDealerRecommendation,
    getRegistrationResults
} from '../../shared/repositories';
import actions from '../../actions-list';
import {buildDealerRecommendationPayload} from '../services/dealer-recommendation-helper';
import {buildRegistrationPayload} from '../../../product/shared/services/build-registration-payload';

export const updateTransferResultsWithFacets = (isInitialLoad, pageno, showMore) =>

    async (dispatch, getState) => {

        dispatch(busyCounter.increaseBusyCounter());

        const facetsDlrRecomm = getState().dealerRecommendationsReducer.facets;

        const dealerRecommendationPayload = buildDealerRecommendationPayload(facetsDlrRecomm, pageno, 50);

        try {

            const dealerRecommendations = await getDealerRecommendation(dealerRecommendationPayload);

            if (showMore) {

                dispatch({
                    data: dealerRecommendations,
                    type: actions.GET_DEALER_RECOMMENDATIONS
                });

            } else {

                dispatch({
                    data: dealerRecommendations,
                    paginationType: 'requestedRecommendation',
                    type: actions.GET_DEALER_RECOMMENDATIONS
                });

            }

            if (isInitialLoad) {

                const facetsReg = getState().registrationReview.facets;

                const registrationPayload = buildRegistrationPayload(facetsReg, '', '');

                const registrationResults = await getRegistrationResults(registrationPayload);

                dispatch({
                    data: registrationResults,
                    type: actions.UPDATE_REGISTRATION_RESULTS
                });

            }

        } catch (error) {

        } finally {

            dispatch(busyCounter.decreaseBusyCounter());

        }

    };

export const resetTransferResults = allowedDealers =>

    dispatch => {

        dispatch({
            allowedDealers,
            type: actions.RESET_TRANSFER_RECOMMENDATION_FACETS
        });

    };



// WEBPACK FOOTER //
// ./src/product/dealer-recommendations/action-creators/facet-updates.js